module.exports = __webpack_public_path__ + "static/media/default-image.9a9886bd.PNG";